import React from "react";

const AlarmRenderer = (props) => {

  return (
    <div>
      {props.data.alarmNbActiv > 0 && <i className="cell-render-icon fas fa-bell" style={{ fontSize: '23px' }} />}
    </div>
  )

}

export default AlarmRenderer;